import { formatToBRL } from "@/utils/formatToMoney";
import { ColumnDef } from "@tanstack/react-table";
import { DataTableColumnHeader } from "./data-table-column-header";
import { DataTableRowActions } from "./data-table-row-actions";
import { TransactionReversal } from "../../data/schema";
import { formatDateToDMY } from "@/utils/format-date-ddmmyyyy";
import { CopyableCell } from "./copyable-cell";

export const columns: ColumnDef<TransactionReversal>[] = [
  {
    accessorKey: "cashier",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Caixa" />
    ),
  },
  {
    accessorKey: "store",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Loja" />
    ),
  },
  {
    accessorKey: "release_sequence",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Sequência" />
    ),
    cell: ({ row }) => (
      <div className=" w-full flex justify-center items-center">
        <span>{row.getValue("release_sequence")}</span>
      </div>
    ),
  },
  {
    accessorKey: "operation_type",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Tipo de Operação" />
    ),
    cell: ({ row }) => {
      const value = row.getValue("operation_type");
      return value ? value : "--";
    },
  },
  {
    accessorKey: "operation_number",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Número" />
    ),
  },

  {
    accessorKey: "operator",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Operador" />
    ),
  },
  {
    accessorKey: "nsu_tef",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="NSU" />
    ),
    cell: ({ row }) => {
      const nsuValue = row.getValue("nsu_tef") as string;
      return <CopyableCell value={nsuValue || ""} label="NSU" />;
    },
  },
  {
    accessorKey: "value",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Valor" />
    ),
    cell: ({ row }) => {
      const value = row.getValue("value");
      return formatToBRL(Number(value) || 0);
    },
  },
  {
    accessorKey: "operation_date",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Data" />
    ),
    cell: ({ row }) => formatDateToDMY(row.getValue("operation_date")),
  },
  {
    accessorKey: "has_refund",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Devolução" />
    ),
    cell: ({ row }) => (
      <div className=" w-full flex justify-center items-center">
        {(row.original as any).has_refund ? (
          <span
            className={`px-2 py-1 rounded-full text-white ${(row.original as any).has_refund === "Sim"
              ? "bg-green-500"
              : "bg-red-500"
              }`}
          >
            {(row.original as any).has_refund}
          </span>
        ) : (
          "--"
        )}
      </div>
    ),
  },
  {
    id: "actions",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];